module.exports = __webpack_public_path__ + "static/media/lottery-prizes-mobile-small.f9190c33.png";